import { createContext, type ReactNode, type RefObject, useContext } from "react";

export interface PageHeaderSlotContextValue {
  headerSlotRef: RefObject<HTMLDivElement | null>;
  /** True after the slot div has been mounted (so ref.current is set). */
  slotReady: boolean;
}

const PageHeaderSlotContext = createContext<PageHeaderSlotContextValue | null>(null);

export function usePageHeaderSlot(): PageHeaderSlotContextValue | null {
  return useContext(PageHeaderSlotContext);
}

interface PageHeaderSlotProviderProps {
  children: ReactNode;
  headerSlotRef: RefObject<HTMLDivElement | null>;
  slotReady: boolean;
}

export function PageHeaderSlotProvider({ children, headerSlotRef, slotReady }: PageHeaderSlotProviderProps) {
  return (
    <PageHeaderSlotContext.Provider value={{ headerSlotRef, slotReady }}>{children}</PageHeaderSlotContext.Provider>
  );
}

export { PageHeaderSlotContext };
